export default "__VITE_ASSET__CNkJm$Ov__"